// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 已读接口 POST /system/notice/read_record/read */
export async function postSystemNoticeReadRecordRead(
  body: API.SystemNoticeReadRequest,
  options?: { [key: string]: any },
) {
  return request<boolean>('/system/notice/read_record/read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
